import PropTypes from 'prop-types';
import { useI18n } from '../../../../../context/I18nContext';
import './AttachmentModal.css';

const AttachmentModalItem = ({
  icon = null,
  label = 'placeholder',
  onClick = () => {},
}) => (
  <div className="attachment-modal-item" onClick={onClick} title={label}>
    <div className="attachment-modal-item-icon">{icon}</div>
    <div className="attachment-modal-item-label">{label}</div>
  </div>
);

AttachmentModalItem.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

const AttachmentModal = ({
  onAttachFileClick = () => {},
}) => {
  const { t } = useI18n();

  return (
    <div className="attachment-modal">
      <AttachmentModalItem
        icon={<ion-icon name="document" />}
        label={t('ChatOptionsView.fromDeviceTitle')}
        onClick={onAttachFileClick}
      />
    </div>
  );
};

AttachmentModal.propTypes = {
  onAttachFileClick: PropTypes.func,
};

export default AttachmentModal;
